import styled from 'styled-components'

const FinanceExampleContainer = styled.div`
  position: relative;
  display: block;
  border: 1px solid ${props => props.theme.color.monochrome.light};
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 24px;

  > p {
    color: ${props => props.theme.color.monochrome.dark};
    margin: 0;
  }
`
const FinanceExampleTitle = styled.div`
  font-weight: ${props => props.theme.font.weight.bold};
  font-size: ${props => props.theme.font.size['label-1']};
  margin: 0;
  padding-bottom: 10px;
`

export { FinanceExampleContainer, FinanceExampleTitle }
